<div class="modal-backdrop">
  <div class="modal-panel">
    <div class="modal-header">
      <h2>{{ 'deleteFormModal.title' | t }}</h2>
      <button
        class="modal-close-btn"
        type="button"
        (click)="onClose()"
        [attr.aria-label]="'modalCommon.closeAria' | t">
        &times;
      </button>
    </div>

    <div class="modal-body">
      <p class="modal-hint">
        {{ 'deleteFormModal.hint' | t }}
      </p>

      @if (showDevHelper) {
        <div class="dev-helper-box" role="note">
          <div class="dev-helper-head">{{ 'modalCommon.devDataTitle' | t }}</div>
          <div class="dev-helper-body">{{ 'deleteFormModal.devBody' | t }}</div>
          <button type="button" class="btn-dev-fill" (click)="insertTestData()">
            {{ 'modalCommon.insertTestData' | t }}
          </button>
        </div>
      }

      <form class="todo-form" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="delete-full-name">{{ 'deleteFormModal.fullName' | t }}</label>
          <input
            id="delete-full-name"
            type="text"
            placeholder="Max Mustermann"
            [ngModel]="fullName()"
            (ngModelChange)="fullName.set($event)"
            name="fullName"
            required />
        </div>

        <div class="form-group">
          <label for="delete-birth-date">{{ 'deleteFormModal.birthDate' | t }}</label>
          <input
            id="delete-birth-date"
            type="date"
            [ngModel]="birthDate()"
            (ngModelChange)="birthDate.set($event)"
            name="birthDate"
            required />
        </div>

        <div class="form-group">
          <label for="delete-request">{{ 'deleteFormModal.request' | t }}</label>
          <textarea
            id="delete-request"
            rows="3"
            [placeholder]="'deleteFormModal.requestPlaceholder' | t"
            [ngModel]="deleteRequest()"
            (ngModelChange)="deleteRequest.set($event)"
            name="deleteRequest"
            required></textarea>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn-cancel"
        (click)="onClose()">
        {{ 'common.close' | t }}
      </button>
      <button
        type="button"
        class="btn-submit"
        [disabled]="!isValid()"
        (click)="onSubmit()">
        {{ 'common.submit' | t }}
      </button>
    </div>
  </div>
</div>
